import {
  FETCH_VEHICLES_DOCUMENTS_DATA,
  FETCH_VEHICLES_DOCUMENTS_SUCCESS,
  FETCH_VEHICLES_DOCUMENTS_FAILURE,
} from "./actionTypes";

export const fetchVehiclesDocumentsData = (driverId) => ({
  type: FETCH_VEHICLES_DOCUMENTS_DATA,
  driverId: driverId
});

export const fetchVehiclesDocumentsSuccess = (data) => ({
  type: FETCH_VEHICLES_DOCUMENTS_SUCCESS,
  payload: data,
});

export const fetchVehiclesDocumentsFailure = (error) => ({
  type: FETCH_VEHICLES_DOCUMENTS_FAILURE,
  payload: error,
});
